import { BaseApi } from "../../../../shared/api/base";
import { Layout } from "../models/layout";

/**
 * HTTP client for the layout builder.
 * Instead of making a request to the API, it will fetch the data from the hidden input element.
 * TODO: remove this once we rewrite page builder with a proper API.
 */
class HiddenInputHTTPClient {
  #HIDDEN_INPUT_SELECTOR = "[id$=layout_grid_data]";
  #hiddenInput;

  get dataSource() {
    this.#hiddenInput ??= document.querySelector(this.#HIDDEN_INPUT_SELECTOR);

    if (!this.#hiddenInput) {
      throw new Error(`Page builder data source not found. (${this.#HIDDEN_INPUT_SELECTOR})`);
    }

    return this.#hiddenInput;
  }

  async request({ method, data }) {
    if (method === "get") {
      const data = JSON.parse(this.dataSource.value);
      return { data };
    }

    if (method === "put") {
      this.dataSource.value = JSON.stringify(data);
      this.dataSource.dispatchEvent(new Event("change", { bubbles: true }));

      return { data };
    }

    throw new Error(`Unsupported method: ${method}`);
  }
}

class LayoutBuilderApi extends BaseApi {
  /**
   * @param {Object} options
   * @param {Object} options.httpClient - Axios like HTTP client.
   *
   * TODO: remove the hidden input HTTP client once we rewrite page builder with a proper API.
   */
  constructor(options = {}) {
    const httpClient = options.httpClient ?? new HiddenInputHTTPClient();
    const model = Layout;

    super({ ...options, model, httpClient });
  }
}

let api;

export function useLayoutBuilderApi() {
  api ??= new LayoutBuilderApi();

  return {
    find: async () => await api.get(),
    save: async (data) => await api.put("", data),
  };
}
